module.exports = __webpack_public_path__ + "static/media/5.chon hinh thuc thanh toan.fd60713c.jpg";